<template>
  <label class="labelRequiredField m-0">
    {{ label }}
    <span class="mandatory-data m-0">*</span>
    <b-form-text v-if="information">{{ information }}</b-form-text>
  </label>
</template>

<script>
export default {
  name: "LabelRequiredField",
  props: {
    label: String,
    information: String,
  },
};
</script>

<style>
.labelRequiredField {
  font-size: 16px;
  color: #333;
}
.mandatory-data {
  font-size: 20px;
  color: #f00;
  padding: 0px !important;
  font-weight: bold;
}
</style>